import _extends from "@babel/runtime-corejs3/helpers/extends";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof _Object$getOwnPropertySymbols === "function") for (var i = 0, p = _Object$getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React, { useContext } from 'react';
import classNames from 'classnames';
import ConfigContext from '../config-provider/ConfigContext';
import { getCompProps } from '../_utils';
// remove this line and code Typography component here
var InternalTypography = function InternalTypography(props, ref) {
  var _useContext = useContext(ConfigContext),
    getPrefixCls = _useContext.getPrefixCls,
    prefixCls = _useContext.prefixCls,
    userDefaultProps = _useContext.compDefaultProps;
  var typographyProps = getCompProps('Typography', userDefaultProps, props);
  var customPrefixcls = typographyProps.prefixCls,
    _typographyProps$comp = typographyProps.component,
    component = _typographyProps$comp === void 0 ? 'article' : _typographyProps$comp,
    className = typographyProps.className,
    ariaLabel = typographyProps['aria-label'],
    children = typographyProps.children,
    restProps = __rest(typographyProps, ["prefixCls", "component", "className", 'aria-label', "children"]);
  var typographyPrefixCls = getPrefixCls(prefixCls, 'typography', customPrefixcls); // 排版样式前缀
  var typographyClasses = classNames(typographyPrefixCls, className, {
    // [`${typographyPrefixCls}-size-${size}`]: size,
    // [`${typographyPrefixCls}-borderless`]: borderType === 'none',
  });
  var Component = component;
  return /*#__PURE__*/React.createElement(Component, _extends({
    className: typographyClasses,
    "aria-label": ariaLabel,
    ref: ref
  }, restProps), children);
};
var Typography = /*#__PURE__*/React.forwardRef(InternalTypography);
Typography.displayName = 'Typography';
export default Typography;